<template>
    <div class="heading">
        <img
            v-bind:src="decoCircle"
            alt=""
            class="headline_iconCircle"
        />
        <div>
            <slot />
        </div>
        <img
            v-bind:src="decoRectangle"
            alt=""
            class="headline_iconRectangle"
        />
    </div>
</template>

<script lang="ts" setup>
    import decoCircle from '@/assets/images/tournamentCenter/TournamentCenterDecoCircle.svg';
    import decoRectangle from '@/assets/images/tournamentCenter/TournamentCenterDecoRectangle.svg';
</script>

<style lang="scss" scoped>
@import "@/views/tournamentCenter/Overview";
</style>
